export default {
      id: "icon-menu-recruitment_evaluation-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "sprite-46b249.svg#icon-menu-recruitment_evaluation-usage",
      toString: function () {
        return this.url;
      }
    }